import { render } from "./AppError404.vue?vue&type=template&id=43b1c003&scoped=true&ts=true"
import script from "./AppError404.vue?vue&type=script&lang=ts"
export * from "./AppError404.vue?vue&type=script&lang=ts"

import "./AppError404.vue?vue&type=style&index=0&id=43b1c003&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b1c003"]])

export default __exports__